import './styles/SecurityInstructionsForm.css';

import type { FormInstance }         from 'antd';
import { AppFormComponent }          from 'components/App/AppForm';
import React                         from 'react';
import { Button }                    from 'antd';
import { Checkbox }                  from 'antd';
import { Col }                       from 'antd';
import { Form }                      from 'antd';
import { InputNumber }               from 'antd';
import Row                           from 'components/App/Row';
import { WarningTwoTone }            from '@ant-design/icons';
import Input                         from 'components/App/IntlInput';
import FormattedMessageWrapper       from 'components/App/FormattedMessageWrapper';
import YesOrNo                       from 'components/App/YesOrNo';
import StandSecurityInstructionModel from 'models/StandSecurityInstructionModel';
import { downloadFileFromUrl }       from 'utils/downloadFile';
import handleFormError               from 'utils/handleFormError';
import ShowModel                     from 'models/ShowModel';
import StandModel                    from 'models/StandModel';
import { messageErrorIntl }          from 'utils/messageIntl';
import { messageSuccessIntl }        from 'utils/messageIntl';

interface SecurityInstructionsFormProps {
  model: StandSecurityInstructionModel;
  onSuccess?: () => void;
  setLoading?: (loading: boolean) => void;
  show: ShowModel;
  stand: StandModel;
}

class SecurityInstructionsForm extends AppFormComponent<SecurityInstructionsFormProps> {
  public static defaultProps = {
    setLoading: () => {
      // do nothing
    },
  };

  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state = {
    builtByMore: false,
    withCoordinator: false,
  };

  public render() {
    return (
      <Form id="SecurityInstructionsForm" ref={this.formRef}>
        <Row>
          <Col span={24}>
            <div className="SecurityInstructionsForm__downloadBox">
              <div>
                <WarningTwoTone style={{ fontSize: '32px' }} twoToneColor="#df5f2c" />
              </div>
              <div>
                <div>
                  <FormattedMessageWrapper id="Télécharger les consignes de sécurité du salon avant de continuer." />
                </div>
                <div>
                  <Button onClick={this.downloadSecurityInstructions} type="primary">
                    <FormattedMessageWrapper id="Télécharger" />
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col span={24}>
            <Form.Item
              className="custom-checkbox"
              name="downloadOk"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
              valuePropName="checked"
            >
              <Checkbox>
                <span className="custom-checkbox-description">
                  <strong>
                    <FormattedMessageWrapper
                      id="Je déclare avoir pris connaissance du document relatif à la prévention des accidents du travail et à la protection de la santé concernant ma participation et je m'engage à m'y conformer sans réserve ni restriction." />
                  </strong>
                </span>
              </Checkbox>
            </Form.Item>
          </Col>
          <Col className="SecurityInstructionsForm__separationCol" span={24}>
            <strong>
              <u>
                <FormattedMessageWrapper id="Personne responsable du stand :" />
              </u>
            </strong>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="lastName"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Prénom" />}
              labelCol={{ span: 24 }}
              name="firstName"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom de la société" />}
              labelCol={{ span: 24 }}
              name="company"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Téléphone" />}
              labelCol={{ span: 24 }}
              name="phone"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={8} sm={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Courriel" />}
              labelCol={{ span: 24 }}
              name="email"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col className="SecurityInstructionsForm__separationCol" span={24}>
            <strong>
              <u>
                <FormattedMessageWrapper id="Votre stand :" />
              </u>
            </strong>
          </Col>
          <Col span={24}>
            <Form.Item
              className="custom-checkbox"
              name="builtByOne"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
              valuePropName="checked"
            >
              <Checkbox
                onChange={event => {
                  this.formRef.current?.setFieldsValue({
                    builtByMore: !event.target.checked,
                  });

                  this.setState({
                    builtByMore: !event.target.checked,
                  });
                }}
              >
                <span className="custom-checkbox-description">
                  <FormattedMessageWrapper
                    id="Construit par l'Organisateur ou par vous-même ou par une par une seule entreprise sans sous-traitant" />
                </span>
              </Checkbox>
            </Form.Item>
          </Col>
          <Col className="SecurityInstructionsForm__separationCol" span={24}>
            <FormattedMessageWrapper id="ou" />
          </Col>
          <Col span={24}>
            <fieldset>
              <Row>
                <Col span={24}>
                  <Form.Item
                    className="custom-checkbox"
                    name="builtByMore"
                    rules={[
                      {
                        message: <FormattedMessageWrapper id="Information manquante" />,
                        required: true,
                      },
                    ]}
                    valuePropName="checked"
                  >
                    <Checkbox
                      onChange={event => {
                        this.formRef.current?.setFieldsValue({
                          builtByOne: !event.target.checked,
                        });

                        this.setState({
                          builtByMore: event.target.checked,
                        });
                      }}
                    >
                      <span className="custom-checkbox-description">
                        <FormattedMessageWrapper
                          id="Construit par au moins deux entreprises indépendantes (sous-traitants inclus)" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
                {this.state.builtByMore === true && (
                  <Col span={24}>
                    <Form.Item
                      className="custom-checkbox"
                      label="Nombre"
                      labelCol={{ span: 24 }}
                      name="numberOfBuilders"
                      rules={[
                        {
                          message: <FormattedMessageWrapper id="Information manquante" />,
                          required: true,
                        },
                      ]}
                      valuePropName="checked"
                    >
                      <InputNumber min={2} />
                    </Form.Item>
                  </Col>
                )}
                <Col span={24}>
                  <Form.Item
                    className="custom-checkbox"
                    name="withMezzanine"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      <span className="custom-checkbox-description">
                        <FormattedMessageWrapper id="Comporte une mezzanine" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    className="custom-checkbox"
                    name="withMoreThanThreeMeterHeights"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      <span className="custom-checkbox-description">
                        <FormattedMessageWrapper
                          id="Comporte des décors d'une hauteur supérieure à 3 mètres" />
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Col>
        </Row>

        {this.state.builtByMore === true && (
          <Row>
            <Col className="SecurityInstructionsForm__separationCol" span={24}>
              <strong>
                <u>
                  <FormattedMessageWrapper id="Coordonnées du standiste :" />
                </u>
              </strong>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item
                label={<FormattedMessageWrapper id="Nom" />}
                labelCol={{ span: 24 }}
                name="standistLastname"
                rules={[
                  {
                    message: <FormattedMessageWrapper id="Information manquante" />,
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item
                label={<FormattedMessageWrapper id="Prénom" />}
                labelCol={{ span: 24 }}
                name="standistFirstname"
                rules={[
                  {
                    message: <FormattedMessageWrapper id="Information manquante" />,
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item
                label={<FormattedMessageWrapper id="Téléphone" />}
                labelCol={{ span: 24 }}
                name="standistPhone"
                rules={[
                  {
                    message: <FormattedMessageWrapper id="Information manquante" />,
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item
                label={<FormattedMessageWrapper id="Courriel" />}
                labelCol={{ span: 24 }}
                name="standistEmail"
                rules={[
                  {
                    message: <FormattedMessageWrapper id="Information manquante" />,
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row>
          <Col span={24}>
            <Form.Item
              className="custom-checkbox"
              label={<FormattedMessageWrapper id="Vous avez un Coordonnateur SPS" />}
              labelCol={{ span: 24 }}
              name="withCoordinator"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <YesOrNo
                onChange={(event: any) => {
                  this.setState({ withCoordinator: event.target.value });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        {!!this.state.withCoordinator && (
          <>
            <Row>
              <Col md={8} sm={24}>
                <Form.Item
                  label={<FormattedMessageWrapper id="Nom" />}
                  labelCol={{ span: 24 }}
                  name="coordinatorLastName"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col md={8} sm={24}>
                <Form.Item
                  label={<FormattedMessageWrapper id="Prénom" />}
                  labelCol={{ span: 24 }}
                  name="coordinatorFirstName"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={8} sm={24}>
                <Form.Item
                  label={<FormattedMessageWrapper id="Téléphone" />}
                  labelCol={{ span: 24 }}
                  name="coordinatorPhone"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col md={8} sm={24}>
                <Form.Item
                  label={<FormattedMessageWrapper id="Courriel" />}
                  labelCol={{ span: 24 }}
                  name="coordinatorEmail"
                  rules={[
                    {
                      message: <FormattedMessageWrapper id="Information manquante" />,
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form>
    );
  }

  public submit = async () => {
    const {
      model,
      onSuccess,
      setLoading,
      setSaveButtonProps,
      stand,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    if (!values.downloadOk) {
      messageErrorIntl("Confirmation manquante");
      return;
    }

    if (setLoading) {
      setLoading(true);
    }

    setSaveButtonProps({ loading: true });

    model.set({
      ...values,
      stand: stand.get('@id'),
    });

    try {
      await model.save();

      messageSuccessIntl("Enregistrement réussi !");

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    } finally {
      if (setLoading) {
        setLoading(false);
      }
      setSaveButtonProps({ loading: false });
    }
  };

  private downloadSecurityInstructions = () => {
    const { show } = this.props;

    downloadFileFromUrl(
      show.securityInstructionsObjectUrl,
      show.securityInstructionsMediaFileName,
    );
  };
}

export default SecurityInstructionsForm;
